"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alphabeticalSort = void 0;
exports.alphabeticalSort = new Intl.Collator('en', { ignorePunctuation: true, numeric: true }).compare;
//# sourceMappingURL=alphabeticalSort.js.map